import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Drawer,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { AppColors } from '../../../../util/AppColors';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRoleList,
  createRole,
  updateRole,
  deleteRole,
} from '../../../../redux/reducers/roleSlice';
// import CustomModal from '../../../../components/CustomModal';
import CustomButton from '../../../../components/CustomButton';
import CustomModal from '../../../../components/CustomModal/CustomModal';
function Roles() {
  const dispatch = useDispatch();

  const [search, setSearch] = useState('');
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ roleName: '' });
  const [delModVisible, setDelModVisible] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);

  const roleList = useSelector((state) =>
    state.role.list.filter((role) => role.type === 'role')
  );

  useEffect(() => {
    dispatch(getRoleList());
  }, [dispatch]);

  const handleAddOrUpdate = () => {
    if (!form.roleName) return;

    if (editIndex !== null) {
      const role = roleList[editIndex];
      dispatch(updateRole({ roleId: role.roleId, roleName: form.roleName })).then(() => {
        closeDrawer();
      });
    } else {
      dispatch(createRole(form)).then(() => {
        dispatch(getRoleList());
        closeDrawer();
      });
    }
  };

  const handleEdit = (index) => {
    const role = roleList[index];
    setEditIndex(index);
    setForm({ roleName: role.roleName });
    setOpenDrawer(true);
  };

  const handleDeleteClick = (index) => {
    setSelectedDeleteIndex(index);
    setDelModVisible(true);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setSelectedDeleteIndex(null);
  };

  const handleDelConfirm = () => {
    const role = roleList[selectedDeleteIndex];
    dispatch(deleteRole({ roleId: role.roleId })).then(() => {
      dispatch(getRoleList());
      handleDelModClose();
    });
  };

  const closeDrawer = () => {
    setForm({ roleName: '' });
    setEditIndex(null);
    setOpenDrawer(false);
  };

  const filteredRows = roleList.filter((row) =>
    row.roleName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box p={3}>
      {/* Top Bar */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} flexWrap="wrap">
        <Box display="flex" gap={2} mx="auto" mb={2}>
          <TextField
            label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ width: '500px', backgroundColor: AppColors.lightPink }}
          />
          <Button variant="contained" onClick={() => setOpenDrawer(true)}>
            Create
          </Button>
        </Box>
        <Typography variant="h6" sx={{ ml: 'auto' }}>
          Total Roles: {filteredRows.length}
        </Typography>
      </Box>

      {/* Scrollable Table */}
      <Box sx={{ mt: 2, height: '60vh', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Role Name</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map((row, index) => (
                  <TableRow key={row.roleId}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.roleName}</TableCell>
                    <TableCell>{new Date(row.createdDate).toLocaleDateString()}</TableCell>
                    <TableCell>{row.userName || '-'}</TableCell>
                    <TableCell>
                      <IconButton color="primary" size="small" onClick={() => handleEdit(index)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton color="error" size="small" onClick={() => handleDeleteClick(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Drawer for Create & Edit */}
      <Drawer anchor="right" open={openDrawer} onClose={closeDrawer}>
        <Box p={3} width={300}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" color="primary">
              {editIndex !== null ? 'Edit Role' : 'Create Role'}
            </Typography>
            <IconButton onClick={closeDrawer} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          <TextField
            fullWidth
            label="Role Name"
            value={form.roleName}
            onChange={(e) => setForm({ ...form, roleName: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: 'absolute',
                top: '50%',
                left: '14px',
                transform: 'translateY(-50%)',
                transition: 'all 0.2s ease-out',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  top: '0px',
                  transform: 'translateY(-50%) scale(0.75)',
                  transformOrigin: 'top left',
                },
              },
            }}
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? 'Update' : 'Add'}
          </Button>
        </Box>
      </Drawer>

      {/* Custom Delete Modal */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
Are you sure you want to delete this record?        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <Button variant="outlined" onClick={handleDelModClose}>Cancel</Button>
          </div>
          <div className="ml10">
            <Button variant="contained" color="error" onClick={handleDelConfirm}>Confirm</Button>
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Roles;

